// extracted by mini-css-extract-plugin
export default {"link":"continue-btn_link__f1HeS"};